// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"312":"b1d0992f","551":"c2ddb01f","842":"01821987"}[chunkId] + ".chunk.js";
};